module.exports = __webpack_public_path__ + "static/media/201CS241.8444638f.jpg";